
















































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import firebase from "firebase/app";
import "firebase/firestore";
const db = firebase.firestore();
import SalonService from "@/services/SalonService";
import TicketFavoriteService from "@/services/TicketFavoriteService";
import SystemConst from "@/config/const";
import { Ticket } from "@/models/ticket";
import { Salon } from "@/models/salon";
// import PurchasedTicketService from "@/services/PurchasedTicketService";
import OkModal from "@/components/OkModal.vue";

@Component({
  name: "TicketBuyDoneApp",
  filters: {
    dateFormat(setDate: any) {
      return moment(setDate).format("YYYY年MM月DD日");
    },

    afterDay(numberDays: number) {
      return moment().add(numberDays, "days");
    },
  },
  components: {
    OkModal
  }
})
export default class TicketBuyDoneApp extends Vue {
  salonId = "";
  ticketId = "";
  ticket: Ticket = new Ticket();
  salon: Salon = new Salon();
  expiredAtDate = new Date();
  title = "";
  SystemConst = SystemConst;
  faved = false;
  isDisabled = false;
  isSecretSale = false;
  errorTitle = "";
  errorMessage = "";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  get getUrl(): string {
    // チケットシェアモード
    const domain = window.location.host;
    const protocol = window.location.protocol;
    return (
      protocol +
      "//" +
      domain +
      "/share-ticket/" +
      this.salon.id +
      "/" +
      String(this.ticket.number)
    );
  }

  get getTitle(): string {
    // タイトル文字をエスケープする
    return encodeURIComponent(this.title);
  }

  get showExpireDate(): boolean {
    return (
      this.ticketType === SystemConst.TICKET_SERVICE_TYPE_ONEC ||
      this.ticketType === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE
    );
  }

  get ticketType() {
    let val: any;
    if (this.ticket.type === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      if (this.ticket.available_count > 1) {
        val = SystemConst.TICKET_SERVICE_TYPE_MULTIPLE;
      } else {
        val = SystemConst.TICKET_SERVICE_TYPE_ONEC;
      }
    } else {
      val = this.ticket.type;
    }
    return val;
  }

  get ticketTypeText() {
    let val = "";
    if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION) {
      val = "定額(サブスク)サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_ONEC) {
      val = "単品サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      val = "回数券サービス";
    }
    return val;
  }

  openUrl(url: string) {
    if (url) {
      window.open(url, "_blank");
    }
  }

  telUrl(tel: string): string {
    return "tel:" + tel;
  }

  async fav() {
    if (this.isDisabled) return;
    this.isDisabled = true;
    await TicketFavoriteService.createTicket({
      ticket_id: this.ticket.id,
    }).then((rsp: any) => (this.faved = true));
    this.isDisabled = false;
  }

  async unFav() {
    if (this.isDisabled) return;
    this.isDisabled = true;
    this.faved = false;
    await TicketFavoriteService.deleteTicket(this.ticket.id).then(
      (rsp: any) => (this.faved = false)
    );
    this.isDisabled = false;
  }

  public async created() {
    this.salonId = this.$route.params.salon_id;
    this.ticketId = this.$route.params.ticket_id;
    const {
      data: { ticket, salon },
    } = await SalonService.getSalonAndTicket(this.salonId, this.ticketId, { view_done: true }).catch(
      (err: any) => {
        return { data: { ticket: null, salon: null } };
      }
    );

    if (!salon || !ticket) {
      this.$router.push({ name: "NotFound" });
    }

    const {
      data: { ticket_favorite },
    } = await TicketFavoriteService.getTicket(this.ticketId);
    this.faved = !!ticket_favorite;
    this.salon = salon;
    this.ticket = ticket;
    if (ticket.sale_method === SystemConst.PURCHASED_TICKET_SECRET_SALE){
      this.isSecretSale = true
    }
    this.setTitle();
    const image_url = this.salon.image_logo_url;
    this.$store.dispatch("actionSetHeaderUrl", image_url);
    this.$store.dispatch("actionSetSalonName", salon.salon_name);

    // const request = this.isSecretSale
    //   ? {
    //       ticket_id: this.ticket.id,
    //       token: this.$route.params.secret_sale_token,
    //       coupon_id: this.$route.params.coupon_id,
    //       salon_id: this.salonId
    //     }
    //   : {
    //       ticket_id: this.ticket.id,
    //       coupon_id: this.$route.params.coupon_id,
    //       salon_id: this.salonId
    //     };
    // try {
    //   await PurchasedTicketService.checkCompletePurchasedTicket(request);
    // } catch (error) {
    //   this.errorTitle = "システムエラー";
    //   this.errorMessage = "管理者にご連絡ください";
    //   this.refs.errorOKModal.open();
    // }
  }

  setTitle() {
    document.title =
      this.ticket.title +
      "を購入しました | " +
      this.salon.salon_name +
      " |  favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    this.title = document.title;
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        this.ticket.title +
          "を購入しました | " +
          this.salon.salon_name +
          " | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }
}
